import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditCardDirectivesModule } from 'angular-cc-library';

import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

import { AccountRoutingModule } from './account-routing.module';
import { AccountDashboardComponent } from './components/account-dashboard/account-dashboard.component';
import { MembershipsComponent } from './components/memberships/memberships.component';
import { MembershipsNewComponent } from './components/memberships-new/memberships-new.component';
import { TrainingCalendarComponent } from './components/training-calendar/training-calendar.component';
import { TrainingHistoryComponent } from './components/training-history/training-history.component';
import { BillingHistoryComponent } from './components/billing-history/billing-history.component';
import { BillingHistoryNewComponent } from './components/billing-history-new/billing-history-new.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { ManageCreditCardsComponent } from './components/manage-credit-cards/manage-credit-cards.component';
import { ManageHistoryComponent } from './components/manage-history/manage-history.component';
import { TrainingListComponent } from './components/training-list/training-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangePasswordNewComponent } from './components/change-password-new/change-password-new.component';
import { DownloadSoftwareComponent } from './components/download-software/download-software.component';

import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { MyProfileNewComponent } from './components/my-profile-new/my-profile-new.component';
import { OverviewComponent } from './components/overview/overview.component';

import { GISHistoryComponent } from './components/gis-history/gis-history.component';
import { GisPurchasesHistoryComponent } from './components/gis-purchases-history/gis-purchases-history.component';
import { GisCreditUsageHistoryComponent } from './components/gis-credit-usage-history/gis-credit-usage-history.component';
import { GISCreditsChooserComponent } from './components/gis-credits-chooser/gis-credits-chooser.component';
import { SharedAppModule } from 'app/app.module.shared';


@NgModule({
  imports: [
    CommonModule,
    SharedAppModule,
    AccountRoutingModule,
    DropdownModule,
    TabViewModule,
    DialogModule,
    TableModule,
    CreditCardDirectivesModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AccountDashboardComponent,
    MembershipsComponent,
    MembershipsNewComponent,
    TrainingCalendarComponent,
    TrainingHistoryComponent,
    BillingHistoryComponent,
    BillingHistoryNewComponent,
    CreditCardComponent,
    ManageCreditCardsComponent,
    ManageHistoryComponent,
    TrainingListComponent,
    ChangePasswordComponent,
    ChangePasswordNewComponent,
    DownloadSoftwareComponent,
    GISHistoryComponent,
    GisPurchasesHistoryComponent,
    GisCreditUsageHistoryComponent,
    GISCreditsChooserComponent,
    MyProfileComponent,
    MyProfileNewComponent,
    OverviewComponent,
  ]
})
export class AccountModule { }
